function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "fans",
  transform: "translate(-2080.293 789.067)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13887",
  "data-name": "Path 13887",
  d: "M2181.557-735.853c7.536-5.966,12.861-11.616,15.894-13.459,6.492,3.607,11.758,11.208,15.873,19.591l19.687-10.355c-10.518-11.621-21.361-14.322-32.327-20.6a174.866,174.866,0,0,1-21.313,5.684A40.718,40.718,0,0,1,2181.557-735.853Z",
  transform: "translate(49.007 14.042)",
  fill: "#5a3cb4"
}), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_26062",
  "data-name": "Grupo 26062",
  transform: "translate(2080.293 -781.925)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_26057",
  "data-name": "Grupo 26057"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_13886",
  "data-name": "Trazado 13886",
  d: "M2096.673-745.118s-4.927,34.065,9.828,33.958,13.933,0,13.933,0L2108.4-747.828Z",
  transform: "translate(-2072.581 802.323)",
  fill: "#bf76fc"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_13873",
  "data-name": "Trazado 13873",
  d: "M2092.919-726.276l30.357-6.385a4.15,4.15,0,0,0,3.208-4.916h0l-6.466-30.755-34.419,7.24Z",
  transform: "translate(-2077.668 792.181)",
  fill: "#ffa012"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_13874",
  "data-name": "Trazado 13874",
  d: "M2110.925-748.533h0a4.421,4.421,0,0,0,3.418-5.236h0l-3.39-16.116a4.422,4.422,0,0,0-5.237-3.417h0a4.423,4.423,0,0,0-3.418,5.237l3.39,16.115a4.421,4.421,0,0,0,5.236,3.418Z",
  transform: "translate(-2069.455 789.676)",
  fill: "#f9cb3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_13875",
  "data-name": "Trazado 13875",
  d: "M2088.934-743.2c1.227,5.837,6.105,9.751,10.9,8.744s7.686-6.558,6.454-12.393-6.107-9.749-10.9-8.742S2087.7-749.038,2088.934-743.2Z",
  transform: "translate(-2076.158 798.404)",
  fill: "#f89310"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_13876",
  "data-name": "Trazado 13876",
  d: "M2105.423-745.947h0a4.421,4.421,0,0,0,3.415-5.237v-.006l-4.255-20.239a4.424,4.424,0,0,0-5.237-3.418h0a4.42,4.42,0,0,0-3.417,5.236h0l4.256,20.246a4.423,4.423,0,0,0,5.238,3.418Z",
  transform: "translate(-2072.606 788.911)",
  fill: "#f9cb3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_13877",
  "data-name": "Trazado 13877",
  d: "M2099.5-745.372h0a4.421,4.421,0,0,0,3.418-5.236h0l-3.849-18.3a4.421,4.421,0,0,0-5.235-3.418h0a4.421,4.421,0,0,0-3.419,5.236h0l3.85,18.3A4.422,4.422,0,0,0,2099.5-745.372Z",
  transform: "translate(-2075.335 790.157)",
  fill: "#f9cb3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_13878",
  "data-name": "Trazado 13878",
  d: "M2094.025-739.213l.615-.134a5.41,5.41,0,0,0,4.192-6.4v-.01l-7.2-34.233a5.412,5.412,0,0,0-6.414-4.178h0l-.615.133a5.415,5.415,0,0,0-4.191,6.407v.009l7.2,34.224a5.412,5.412,0,0,0,6.409,4.185Z",
  transform: "translate(-2080.293 784.289)",
  fill: "#f9cb3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_13879",
  "data-name": "Trazado 13879",
  d: "M2093.274-728.8l8.688-1.826-6.5-30.925a2,2,0,0,0-2.366-1.538h0a10.928,10.928,0,0,0-8.446,12.944h0l3.83,18.221A4.051,4.051,0,0,0,2093.274-728.8Z",
  transform: "translate(-2078.255 794.75)",
  fill: "#f89310"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Path_13888",
  "data-name": "Path 13888",
  d: "M2123.136-743.2a130.379,130.379,0,0,0,11,7.766,50.214,50.214,0,0,1,.931-17.148c-9.769-.2-16.414-.614-18-.67a40.36,40.36,0,0,0-14.879,12.305l10.954,7.839C2116.232-740.762,2120.849-742.964,2123.136-743.2Z",
  transform: "translate(10.831 17.717)",
  fill: "#5a3cb4"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13889",
  "data-name": "Path 13889",
  d: "M2164.522-733.609c-.416,6.775-.488,12.885-.278,18.376h14.986c-4.039-12.5-7.635-24.356-7.635-24.356A12.434,12.434,0,0,0,2164.522-733.609Z",
  transform: "translate(41.469 24.473)",
  fill: "#e49963"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13890",
  "data-name": "Path 13890",
  d: "M2164.522-733.609c-.416,6.775-.488,12.885-.278,18.376h14.986c-4.039-12.5-7.635-24.356-7.635-24.356A12.434,12.434,0,0,0,2164.522-733.609Z",
  transform: "translate(41.469 24.473)",
  fill: "#e49963"
}), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_26059",
  "data-name": "Grupo 26059",
  transform: "translate(2152.941 -789.067)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_13880",
  "data-name": "Trazado 13880",
  d: "M2187.637-743.565c-19.58-9.4-39.159,6.539-58.739-16.181a272.9,272.9,0,0,0,12.646-29.321c19.579,8.6,39.159-7.675,58.738,15.17C2196.069-765.29,2191.853-754.967,2187.637-743.565Z",
  transform: "translate(-2128.899 789.067)",
  fill: "#5a3cb4"
}), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_26058",
  "data-name": "Grupo 26058",
  transform: "translate(2.287 5.971)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_13881",
  "data-name": "Trazado 13881",
  d: "M2192.72-764.785c-19.579-16.768-39.159.088-58.738-13.438q1.381-3.32,2.762-6.848c19.58,10.717,39.16-5.941,58.739,14.035Q2194.1-768.022,2192.72-764.785Z",
  transform: "translate(-2128.671 785.072)",
  fill: "#f9cb3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_13882",
  "data-name": "Trazado 13882",
  d: "M2189.168-755.849c-19.58-11.394-39.159,5.047-58.739-14.679q1.381-2.87,2.762-5.987c19.579,16.372,39.159-.414,58.738,13.643Q2190.549-759.453,2189.168-755.849Z",
  transform: "translate(-2130.429 789.304)",
  fill: "#f9cb3f"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_13884",
  "data-name": "Trazado 13884",
  d: "M2161.219-743.753c5.21-5.542,4.75-1.759,6.285-.185,4.334,4.453,1.829-3.983,3.886-5.653,1.825-1.481,5.88,7.4,3.372,15.843l-7.083,5.766C2160.74-728.732,2154.245-735.479,2161.219-743.753Z",
  transform: "translate(38.549 19.445)",
  fill: "#e49963"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_13885",
  "data-name": "Trazado 13885",
  d: "M2156.73-701.655l-.334-.136a1.837,1.837,0,0,1-1-2.391l30.694-74.473a1.837,1.837,0,0,1,2.391-1l.334.136a1.835,1.835,0,0,1,1,2.391l-30.7,74.473A1.834,1.834,0,0,1,2156.73-701.655Z",
  transform: "translate(37.079 4.587)",
  fill: "#bf76ff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_13868",
  "data-name": "Trazado 13868",
  d: "M2201.863-752.574c-.066-.2-.151-.3-.121-.483a.09.09,0,0,0-.1.076h0c-1.605.8-3.423.448-3.91-.732-.065-.2-.133-.393-.2-.589a2.435,2.435,0,0,1-2.553-1.1,1.861,1.861,0,0,1-.134-1.046,2.42,2.42,0,0,1-2.722-1.221,2.571,2.571,0,0,1,1.462-3.327l.032-.012a2.654,2.654,0,0,1,3.519.865,1.558,1.558,0,0,1,.149.953,2.828,2.828,0,0,1,3.519.865l.2.588a2.434,2.434,0,0,1,2.553,1.1,1.809,1.809,0,0,1,.151.953,2.083,2.083,0,0,1,2.382.987,2.21,2.21,0,0,1-1.231,2.814A2.252,2.252,0,0,1,2201.863-752.574Z",
  transform: "translate(55.226 13.71)",
  fill: "#e49963"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_13869",
  "data-name": "Trazado 13869",
  d: "M2108.9-744.462a1,1,0,0,0,.068-.493.093.093,0,0,1,.112.066v0c1.677.637,3.451.107,3.816-1.124l.137-.6a2.434,2.434,0,0,0,2.429-1.356,1.848,1.848,0,0,0,.027-1.046,2.421,2.421,0,0,0,2.587-1.495,2.572,2.572,0,0,0-1.795-3.164l-.029-.007a2.655,2.655,0,0,0-3.414,1.217,1.576,1.576,0,0,0-.05.964,2.826,2.826,0,0,0-3.413,1.215l-.139.6a2.436,2.436,0,0,0-2.428,1.356,1.773,1.773,0,0,0-.05.964,2.085,2.085,0,0,0-2.27,1.221,2.209,2.209,0,0,0,1.51,2.675A2.255,2.255,0,0,0,2108.9-744.462Z",
  transform: "translate(11.931 17.396)",
  fill: "#e49963"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_26068",
  "data-name": "Group 26068",
  transform: "translate(2125.6 -744.176)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13891",
  "data-name": "Path 13891",
  d: "M2128.468-708.166c-.846-9.057-1.21-17.074-1.366-22.092,1.5-9.415-4.98-19.369-5.833-20.251-2.2-2.3-3.1-3.511-3.563-3.354s-2.905,1.771.193,5.213c2.5,2.771,4.059,8.032,1.068,5.765-2.82-.495-6.7,3.923-8.361,6.264a25.422,25.422,0,0,0,8.685,7.065,166.961,166.961,0,0,0-4.4,21.39Z",
  transform: "translate(-2110.606 761.582)",
  fill: "#e49963"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13892",
  "data-name": "Path 13892",
  d: "M2206.069-705.616a184.854,184.854,0,0,0-8.364-31.308c1.228-1.146,1.913-4.324,3-6.895.327-.746-4.784-5.016-7.434-6.307-1.411,1.477-1.714-1.607-.747-4.324,1.458-4.082-1.229-4.611-1.689-4.581s-.8,1.4-1.887,4.171c-.421,1.066-3.083,12.169,1.59,19.786h0c.313,5.988.727,17.12.372,29.459Z",
  transform: "translate(-2072.417 759.032)",
  fill: "#e49963"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_13893",
  "data-name": "Path 13893",
  d: "M2253.1-723.72c-1.238-3.251-2.637-6.561-4.208-9.761-4.115-8.383-9.382-15.985-15.873-19.591-3.033,1.843-8.358,7.493-15.894,13.459a101.452,101.452,0,0,1-9.919,6.974,71.425,71.425,0,0,1-19.581,8.462,60.576,60.576,0,0,1-11.518,1.794,62.434,62.434,0,0,1-16.117-1.2,71.959,71.959,0,0,1-9.113-2.489,86.558,86.558,0,0,1-11.308-4.86q-3.944-2.02-8.04-4.587a130.407,130.407,0,0,1-11-7.766c-2.287.232-6.9,2.433-9.993,10.093a38.314,38.314,0,0,0-2.083,7.443,67.546,67.546,0,0,0-.986,11.9c0,1.667.04,3.432.133,5.284h150.407c-.634-2.318-1.4-4.941-2.306-7.745C2254.931-718.683,2254.065-721.179,2253.1-723.72Z",
  transform: "translate(13.44 17.803)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13894",
  "data-name": "Path 13894",
  d: "M2128.948-731.07a86.575,86.575,0,0,0,11.308,4.86,101.887,101.887,0,0,1,2.42-26.577c-4.213.084-8.217.106-11.943.091C2129.094-747.179,2128.89-737.241,2128.948-731.07Z",
  transform: "translate(24.062 17.945)",
  fill: "#5a3cb4"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13895",
  "data-name": "Path 13895",
  d: "M2204.9-730.231c.967,2.541,1.832,5.037,2.6,7.412a38.714,38.714,0,0,0,27.446-3.985,112.4,112.4,0,0,0-6.838-13.1C2218.747-731.144,2209.691-730.046,2204.9-730.231Z",
  transform: "translate(61.635 24.315)",
  fill: "#5a3cb4"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13896",
  "data-name": "Path 13896",
  d: "M2142.654-723.336a62.43,62.43,0,0,0,16.117,1.2c.8-6.771,2.363-21.54,1.98-31.426-5.578.426-11.036.722-16.269.921C2143.634-746.876,2142.037-734.089,2142.654-723.336Z",
  transform: "translate(30.777 17.56)",
  fill: "#5a3cb4"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13897",
  "data-name": "Path 13897",
  d: "M2161.578-724.321c-.156.475-.317.919-.481,1.345a71.418,71.418,0,0,0,19.581-8.463,43.515,43.515,0,0,0-3.668-24.065c-4.931.77-9.9,1.406-14.83,1.93C2163.215-747.722,2164.924-734.508,2161.578-724.321Z",
  transform: "translate(39.968 16.602)",
  fill: "#5a3cb4"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13898",
  "data-name": "Path 13898",
  d: "M2114.77-732.751a28.84,28.84,0,0,1-14.625-6.158,88.7,88.7,0,0,0-5.457,13.145c5.823,3.747,14.288,4.69,19.1,4.911A67.549,67.549,0,0,1,2114.77-732.751Z",
  transform: "translate(7.121 24.809)",
  fill: "#5a3cb4"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13899",
  "data-name": "Path 13899",
  d: "M2206.643-727.156c.906,2.8,1.672,5.427,2.306,7.745H2238.8c-1.559-4.3-3.128-8.191-4.708-11.73A38.715,38.715,0,0,1,2206.643-727.156Z",
  transform: "translate(62.496 28.652)",
  fill: "#f9cb3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13900",
  "data-name": "Path 13900",
  d: "M2206.3-726.777c4.789.185,13.845-.913,23.208-9.678a70.67,70.67,0,0,0-7.728-10.438l-19.687,10.355C2203.659-733.338,2205.058-730.028,2206.3-726.777Z",
  transform: "translate(60.243 20.86)",
  fill: "#f9cb3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13901",
  "data-name": "Path 13901",
  d: "M2114.724-725.2c-4.807-.221-13.272-1.164-19.1-4.911-1.127,3.43-2.061,6.863-2.84,10.195h22.068C2114.764-721.771,2114.719-723.536,2114.724-725.2Z",
  transform: "translate(6.181 29.159)",
  fill: "#f9cb3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13902",
  "data-name": "Path 13902",
  d: "M2115.047-737.175l-10.954-7.839a61.481,61.481,0,0,0-5.752,9.125,28.838,28.838,0,0,0,14.625,6.158A38.315,38.315,0,0,1,2115.047-737.175Z",
  transform: "translate(8.927 21.79)",
  fill: "#f9cb3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13903",
  "data-name": "Path 13903",
  d: "M2123.68-735.651q4.1,2.574,8.04,4.587c-.057-6.171.146-16.109,1.784-21.626-3.18-.01-6.158-.052-8.893-.109A50.219,50.219,0,0,0,2123.68-735.651Z",
  transform: "translate(21.289 17.939)",
  fill: "#f9cb3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13904",
  "data-name": "Path 13904",
  d: "M2175.412-730.76a101.5,101.5,0,0,0,9.918-6.974,40.727,40.727,0,0,0-2.187-19.14c-3.756.77-7.566,1.45-11.4,2.049A43.521,43.521,0,0,1,2175.412-730.76Z",
  transform: "translate(45.234 15.923)",
  fill: "#f9cb3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13905",
  "data-name": "Path 13905",
  d: "M2153.391-721.82a60.56,60.56,0,0,0,11.517-1.794c.165-.426.326-.87.481-1.345,3.346-10.187,1.636-23.4.6-29.253-3.57.378-7.116.7-10.62.965C2155.753-743.361,2154.195-728.591,2153.391-721.82Z",
  transform: "translate(36.156 17.24)",
  fill: "#f9cb3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13906",
  "data-name": "Path 13906",
  d: "M2136.538-726.129a71.969,71.969,0,0,0,9.113,2.489c-.617-10.754.981-23.54,1.828-29.31-2.917.109-5.763.19-8.521.244A101.887,101.887,0,0,0,2136.538-726.129Z",
  transform: "translate(27.78 17.864)",
  fill: "#f9cb3f"
}));
function SvgHowItWorksEnjoy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 221,
    height: 98.308,
    viewBox: "0 0 221 98.308",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowItWorksEnjoy);
export default __webpack_public_path__ + "static/media/howItWorksEnjoy.629cd309f72028192aecb3aaecfb71fe.svg";
export { ForwardRef as ReactComponent };